import BrowserRuntimeContextManager from '../../src/browser';

export const ContextManager = new BrowserRuntimeContextManager();
